<template>
  <div>
    <div class="sc-exqJjn eVcNXl" style="opacity: 1;">
      <div class="sc-ktvXtq kCDMfd">
        <div class="sc-bFSanr bhFDDX">
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" class="sc-kHVJdr eXqyOM" @click="voltar()">
            <path d="M12.8328 6.82939H3.97417L7.82577 2.99422C8.04555 2.77471 8.16902 2.477 8.16902 2.16657C8.16902 1.85614 8.04555 1.55842 7.82577 1.33892C7.60599 1.11941 7.3079 0.996094 6.99709 0.996094C6.68628 0.996094 6.38819 1.11941 6.16841 1.33892L0.332654 7.16745C0.226396 7.27831 0.143102 7.40904 0.0875521 7.55213C-0.0291841 7.83594 -0.0291841 8.15426 0.0875521 8.43807C0.143102 8.58116 0.226396 8.71189 0.332654 8.82275L6.16841 14.6513C6.27691 14.7605 6.406 14.8473 6.54823 14.9064C6.69046 14.9656 6.84301 14.9961 6.99709 14.9961C7.15117 14.9961 7.30372 14.9656 7.44595 14.9064C7.58818 14.8473 7.71727 14.7605 7.82577 14.6513C7.93516 14.5429 8.02199 14.414 8.08125 14.2719C8.1405 14.1299 8.17101 13.9775 8.17101 13.8236C8.17101 13.6697 8.1405 13.5174 8.08125 13.3753C8.02199 13.2333 7.93516 13.1043 7.82577 12.996L3.97417 9.1608H12.8328C13.1424 9.1608 13.4393 9.03799 13.6581 8.81938C13.877 8.60077 14 8.30426 14 7.9951C14 7.68593 13.877 7.38943 13.6581 7.17082C13.4393 6.95221 13.1424 6.82939 12.8328 6.82939Z" fill="#30333C"></path>
          </svg>
        </div>
        <div class="sc-gXZlrW etflNL">
          <input :value='termoBusca' @input='evt=>termoBusca=evt.target.value' v-on:keyup="Pesquisar" type="text" placeholder="Buscar produtos" theme="[object Object]" class="sc-fyFmx jbSGrn" value="" style="margin: 5px;" />
        </div>
      </div>
      <div class="sc-dkiTmt jkibmf"  v-if="((produtosFiltrado.length == 0) || (termoBusca == ''))">
        <img alt="nenhuma busca" src="@/assets/mobile_app_p3ts.svg" />
        <p class="title">Nenhuma busca até o momento</p>
        <p class="message">Faça sua primeira busca aqui</p>
      </div>
    </div>
    <div class="sc-exqJjn eVcNXl" style="margin-top: 8px" v-if="((produtosFiltrado.length > 0) && (termoBusca != ''))">
      <div style="max-width: 800px;">
        <div class="scrollspy grupo-scroll"  v-if="produtosFiltrado.length > 0">
          <titulo-destacado class="lb-grupo" titulo="Resultados"></titulo-destacado>
          <item class="row" v-for="produto in produtosFiltrado" :key="produto.id" :produto="produto" :grupo="produto.grupo_nome.toLocaleUpperCase()"></item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TituloDestacado from "../Widgets/TituloDestacado";
import Item from "../Widgets/Item";
export default {
  name: "Pesquisa",
  components: {Item, TituloDestacado},
  data(){
    return{
      resultados:false,
      grupos: this.$store.state.grupos,
      gruposPers: [],
      gruposFiltro: [],
      termoBusca:'',
      produtos:[],
      produtosFiltrado:[]
    }
  },
  mounted() {
    this.grupos.forEach(res =>{
      res.produtos.forEach(prod =>{
        prod.grupo_nome =  res.nome;
        prod.filtros = prod.nome + ' - ' + prod.descricao;
        this.produtos.push(prod);
      })
    });
  },
  methods:{
    voltar(){
      this.$router.push('/'+this.$store.state.empresa_url + '/menu');
    },
    Pesquisar() {
        let termo = this.termoBusca.trim().toUpperCase();

        if (!termo) {
          this.produtosFiltrado = [];
          return;
        }

        // Filtra todos os produtos que contêm o termo no título ou na descrição
        let filtrado = this.produtos.filter(produto => 
          (produto.nome && produto.nome.toUpperCase().includes(termo)) ||
          (produto.descricao && produto.descricao.toUpperCase().includes(termo))
        );

        // Ordena os resultados:
        // 1. Produtos com o termo exatamente no título (maior relevância)
        // 2. Produtos com o termo em qualquer parte do título
        // 3. Produtos com o termo na descrição
        filtrado.sort((a, b) => {
          const aTituloExato = a.nome.toUpperCase() === termo;
          const bTituloExato = b.nome.toUpperCase() === termo;

          const aTituloContem = a.nome.toUpperCase().includes(termo);
          const bTituloContem = b.nome.toUpperCase().includes(termo);

          const aDescricaoContem = a.descricao && a.descricao.toUpperCase().includes(termo);
          const bDescricaoContem = b.descricao && b.descricao.toUpperCase().includes(termo);

          // Prioriza produtos com o termo exatamente no título
          if (aTituloExato && !bTituloExato) return -1;
          if (!aTituloExato && bTituloExato) return 1;

          // Depois, produtos com o termo em qualquer parte do título
          if (aTituloContem && !bTituloContem) return -1;
          if (!aTituloContem && bTituloContem) return 1;

          // Por último, produtos com o termo na descrição
          if (aDescricaoContem && !bDescricaoContem) return -1;
          if (!aDescricaoContem && bDescricaoContem) return 1;

          return 0; // Mantém a ordem original se não houver diferença
        });

        this.produtosFiltrado = filtrado;
      }

  }
}
</script>

<style scoped>
.eVcNXl .summary {
  color: rgb(127, 143, 159);
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  text-align: center;
  padding: 8px;
}


.jkibmf img {
  width: auto;
  height: 130px;
  max-width: 240px;
}

.etflNL > .search {
  width: 12px;
  height: 12px;
  margin: 0px 14px 0px 12px;
  display: block;
}

.etflNL {
  height: 34px;
  width: calc(100vw - 64px);
  margin: 8px 16px 8px 0px;
  border: 1px solid rgb(111 111 111);
  border-radius: 4px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}
.etflNL > .search {
  width: 12px;
  height: 12px;
  margin: 0px 14px 0px 12px;
  display: block;
}
.jbSGrn {
  width: calc(100% - 78px);
  margin: 0px;
  border: none;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  cursor: text;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  color: rgb(127, 143, 159);
  resize: none;
}
.kCDMfd {
  position: fixed;
  top: 0px;
  z-index: 100;
  height: 48px;
  margin: 0px;
  padding: 0px;
  max-width: 800px;
  border-bottom: 1px solid rgb(232, 234, 237);
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: start;
  justify-content: flex-start;
  background: rgb(255, 255, 255);
}
.jkibmf {
  width: 100%;
  margin-top: 37px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  flex-direction: column;
}
.jkibmf > .title {
  width: 100%;
  margin-top: 12px;
  max-width: 240px;
  color: rgb(48, 51, 60);
  font-size: 20px;
  font-weight: bold;
  line-height: 140%;
  text-align: center;
}
.bhFDDX {
  width: 48px;
  height: 48px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  cursor: pointer;
}
.jbSGrn {
  width: calc(100% - 78px);
  margin: 0px;
  border: none;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  cursor: text;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  color: rgb(127, 143, 159);
  resize: none;
}
.kCDMfd {
  position: fixed;
  top: 0px;
  z-index: 100;
  height: 48px;
  margin: 0px;
  padding: 0px;
  max-width: 800px;
  border-bottom: 1px solid rgb(232, 234, 237);
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: start;
  justify-content: flex-start;
  background: rgb(255, 255, 255);
}

.eVcNXl {
  position: relative;
  padding-top: 48px;
  width: 100%;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  flex-direction: column;
  background: rgb(255, 255, 255);
}

input:not([type]):focus:not([readonly]), input[type=text]:not(.browser-default):focus:not([readonly]), input[type=password]:not(.browser-default):focus:not([readonly]), input[type=email]:not(.browser-default):focus:not([readonly]), input[type=url]:not(.browser-default):focus:not([readonly]), input[type=time]:not(.browser-default):focus:not([readonly]), input[type=date]:not(.browser-default):focus:not([readonly]), input[type=datetime]:not(.browser-default):focus:not([readonly]), input[type=datetime-local]:not(.browser-default):focus:not([readonly]), input[type=tel]:not(.browser-default):focus:not([readonly]), input[type=number]:not(.browser-default):focus:not([readonly]), input[type=search]:not(.browser-default):focus:not([readonly]), textarea.materialize-textarea:focus:not([readonly]) {
  border-bottom: 0px solid #26a69a;
  -webkit-box-shadow: 0 0px 0 0 #26a69a;
  box-shadow: 0 0px 0 0 #26a69a;
}

input:not([type]), input[type=text]:not(.browser-default), input[type=password]:not(.browser-default), input[type=email]:not(.browser-default), input[type=url]:not(.browser-default), input[type=time]:not(.browser-default), input[type=date]:not(.browser-default), input[type=datetime]:not(.browser-default), input[type=datetime-local]:not(.browser-default), input[type=tel]:not(.browser-default), input[type=number]:not(.browser-default), input[type=search]:not(.browser-default), textarea.materialize-textarea {
  border-bottom: 0px solid #9e9e9e;
}

</style>



// WEBPACK FOOTER //
// src/components/Paginas/Pesquisa.vue